enum WorkOrderReportStatusEnum {
    pending,
    processing,
    completed,
    failed
}

export default WorkOrderReportStatusEnum;
